export default __webpack_public_path__ + "locales/sq-AL/ChangeUserStatusDialog.json?hash=d0d52cf6a9f53de63c5803c1f9ae594b";